import sheshaTheme from "../sheshaTheme"
import auroraPayTheme from "../auroraPayTheme"
import defaultTheme from "../defaultTheme"
import paywellTheme from "../paywellTheme"
import wellPayTheme from "../wellPayTheme"

const themeSelector = (companyName: string) => {
  switch (companyName) {
    case "paywell":
      return paywellTheme
    case "wellpay":
      return wellPayTheme
    case "aurorapay":
      return auroraPayTheme
    case "shesha":
      return sheshaTheme
    default:
      return defaultTheme
  }
}

export default themeSelector
